import React from 'react';
import {connect} from 'react-redux';

import {selectCurrentUserTeams, selectCurrentUserPermissions} from 'ducks/auth';
import {hasEntityPermissionOrTeamOwnership} from 'utils/permissions';

class VisibleIfTeamOwner extends React.Component<any> {
  render() {
    const {
      not,
      team,
      permission,
      userTeams,
      userPermissions,
      locationRef,
      children
    } = this.props;

    const hasPermission = hasEntityPermissionOrTeamOwnership({
      userTeams,
      userPermissions,
      permission,
      locationRef,
      teamId: team.id
    });

    // user has no permission and "not" is false
    if (!hasPermission && !not) {
      return null;
    }

    // user has permission but "not" is true
    if (hasPermission && !!not) {
      return null;
    }

    return children;
  }
}

const mapStateToProps = state => ({
  userTeams: selectCurrentUserTeams(state),
  userPermissions: selectCurrentUserPermissions(state)
});

export default connect(mapStateToProps)(VisibleIfTeamOwner);
